import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-office',
  templateUrl: './office.component.html',
  styleUrls: ['./office.component.css']
})
export class OfficeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// ./src/app/master/office/office.component.ts